// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip__wrapper__e918329289a8c15a6a35","tooltip":"Tooltip__tooltip__d2054ab2ff47d92f5d53","tooltipTheme":"Tooltip__tooltipTheme__c063153198be2287d403"};